import { render, staticRenderFns } from "./AdminInvoiceDetail.vue?vue&type=template&id=42beb4bf&scoped=true"
import script from "./AdminInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminInvoiceDetail.vue?vue&type=style&index=0&id=42beb4bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42beb4bf",
  null
  
)

export default component.exports